module.exports = __webpack_public_path__ + "static/img/top_left.78f7af9a.png";